export default __webpack_public_path__ + "static/media/roof-work.74f2fc5d.jpg";